import { render, staticRenderFns } from "./BeautyConfiguration.vue?vue&type=template&id=9a352f3e&scoped=true"
import script from "./BeautyConfiguration.vue?vue&type=script&lang=js"
export * from "./BeautyConfiguration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a352f3e",
  null
  
)

export default component.exports